export const characters = [
  {
    id: "mere_isolee",
    name: "La Matriarche des Allocs",
    title: "Mere Isolee x 12 Enfants",
    emoji: "\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d\udc66",
    description: "12 enfants, 0 pere en vue. Son arme secrete : la culpabilite administrative.",
    hp: 120, maxHp: 120,
    atk: 10, def: 8, luck: 5,
    passive: { name: "Force du Nombre", desc: "+1 ATK par enfant par tour (stack jusqu'a 12)", type: "atk_stack", value: 1, max: 12 },
    color: "pink"
  },
  {
    id: "etudiant",
    name: "Le Fantome du CROUS",
    title: "Etudiant Boursier Imaginaire",
    emoji: "\ud83d\udc7b",
    description: "Inscrit dans 3 facs, present dans aucune. Sa bourse arrive avant lui.",
    hp: 80, maxHp: 80,
    atk: 14, def: 4, luck: 15,
    passive: { name: "Intouchable", desc: "+30% esquive (il est jamais la ou on le cherche)", type: "dodge", value: 30 },
    color: "blue"
  },
  {
    id: "retraite",
    name: "Le Veteran du Systeme",
    title: "Retraite Qui Cumule",
    emoji: "\ud83d\udc74",
    description: "40 ans de carriere a esquiver les controles. Il connait TOUTES les failles.",
    hp: 100, maxHp: 100,
    atk: 8, def: 12, luck: 10,
    passive: { name: "Blindage Administratif", desc: "+5 DEF par tour (il connait toutes les failles)", type: "def_stack", value: 5, max: 50 },
    color: "amber"
  },
  {
    id: "auto_entrepreneur",
    name: "Le Micro du Micro",
    title: "Auto-Entrepreneur Fantome",
    emoji: "\ud83d\udcbc",
    description: "0EUR de CA, 100% de deductions. Son business plan tient sur un post-it.",
    hp: 70, maxHp: 70,
    atk: 18, def: 3, luck: 8,
    passive: { name: "Desespoir Productif", desc: "Degats x2 quand HP < 30%", type: "crit_low_hp", value: 30 },
    color: "emerald"
  },
  {
    id: "rsa_philosophe",
    name: "Le Penseur Subventionne",
    title: "RSA Philosophe",
    emoji: "\ud83e\udd14",
    description: "Il ne cherche pas d'emploi, il cherche un sens a la vie. Pole Emploi cherche son dossier.",
    hp: 90, maxHp: 90,
    atk: 12, def: 6, luck: 12,
    passive: { name: "Zenitude Administrative", desc: "Regenere 5 HP par tour", type: "regen", value: 5 },
    color: "violet"
  }
];
